import React from 'react';

import { lensTokens } from '~/configs/unifiedAnalyticsTheme';

import CloseIcon from '@mui/icons-material/Close';
import { Chip } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

import { TOUR_COPY } from './tourTypes';
import { useTour } from './useTour';

/** Small prompt on a shared Lens for people who have not taken the tour. */
export default function TourChip() {
  const theme = useTheme();
  const tokens = lensTokens(theme);
  const tour = useTour();

  if (!tour.chipVisible) return null;

  return (
    <Chip
      deleteIcon={<CloseIcon aria-label="Close" titleAccess="Close" />}
      label={TOUR_COPY.chip}
      onClick={() => tour.start('chip')}
      onDelete={() => tour.dismiss('chip')}
      size="small"
      sx={{
        borderColor: alpha(tokens.accent, 0.4),
        color: tokens.accent,
        flexShrink: 0,
        '& .MuiChip-deleteIcon': { color: tokens.accent, fontSize: 16, lineHeight: 1, mr: 0.75 },
      }}
      variant="outlined"
    />
  );
}
